import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import AdminLayout from '../view/admin/AdminLayout'
// 安装路由
Vue.use(VueRouter);

// 配置导出路由(纯管理端:仅登录 + 管理后台,客户端功能已分离至 im-web)
export default new VueRouter({
  routes: [{
    path: "/",
    redirect: "/login"
  },
  {
    name: "Login",
    path: '/login',
    component: Login
  },
  {
    name: "Admin",
    path: '/admin',
    component: AdminLayout,
    redirect: "/admin/system",
    children: [
      {
        name: "AdminSystem",
        path: "/admin/system",
        component: () => import("../view/admin/SystemConfig")
      },
      {
        name: "AdminUser",
        path: "/admin/user",
        component: () => import("../view/admin/UserManage")
      },
      {
        name: "AdminGroup",
        path: "/admin/group",
        component: () => import("../view/admin/GroupManage")
      },
      {
        name: "AdminSensitive",
        path: "/admin/sensitive",
        component: () => import("../view/admin/SensitiveManage")
      },
      {
        name: "AdminRealname",
        path: "/admin/realname",
        component: () => import("../view/admin/RealnameAudit")
      },
      {
        name: "AdminWallet",
        path: "/admin/wallet",
        component: () => import("../view/admin/WalletAdmin")
      },
      {
        // 外链管理已整合进系统配置页的外链配置标签,旧入口重定向保留兼容
        path: "/admin/promotion",
        redirect: "/admin/system?tab=promotion"
      }
    ]
  }
  ]

});
